import React from "react";
import SignOut from "components/auth/SignOut";
import { IconSettings, IconUser } from "components/common/icons/twoToneIcons";
import { MY_USER } from "constants/routes";
import AppSettingsMenu from "./AppSettingsMenu";
import styles from "./AppSettingsMenu.module.scss";
import { useSelector } from "react-redux";
import { currentUserSelector } from "store/selectors/core.selectors";

const UserSettings = () => (
  <AppSettingsMenu
    options={[
      {
        key: "details",
        children: "My Details",
        to: MY_USER.path,
      },
      {
        key: "signout",
        children: <SignOut className={styles.menuItemButton} />,
      },
    ]}
    aria-label={"User Settings"}
    header={<UserHeader />}
  >
    <IconSettings />
  </AppSettingsMenu>
);

const UserHeader = () => {
  const user = useSelector(currentUserSelector);
  return (
    <div className={styles.header}>
      <IconUser className={styles.icon} />
      <div className={styles.title}>
        {`${user.firstname} ${user.surname}`}
        <br />
        <span>{user.email}</span>
      </div>
    </div>
  );
};

export default UserSettings;
